import { PropsWithChildren, ReactNode } from 'react';
import { Spinner, Button } from '@ds';
import { useStreamChatContext } from '@features/contexts/ChatProvider';
import { useChatContext } from 'stream-chat-react';

export const ChatConnectionGate = ({ children }: PropsWithChildren) => {
  const { client: chatClient } = useChatContext();
  const { isStreamTokenError, isConnecting, isConnected, isConnectionError, connectToChat } = useStreamChatContext();

  if (isStreamTokenError) {
    return (
      <div className="flex items-center justify-center h-full text-base-5 text-m-r">
        Failed to connect to chat. Please try refreshing or contact support.
      </div>
    );
  }

  if ((isConnectionError || !isConnected) && chatClient) {
    return (
      <div className="w-full h-full flex items-center pt-4 flex-col gap-2">
        <div className="flex items-center flex-col">
          <span className="text-m-r text-base-5">Failed to connect to chats.</span>
          <span className="text-m-r text-base-5">Please try reconnecting.</span>
        </div>
        <Button variant="solid" type="button" size="sm" onPress={connectToChat}>
          Connect
        </Button>
      </div>
    );
  }

  if (!chatClient || isConnecting) {
    return (
      <div className="flex items-center justify-center h-full">
        <Spinner />
      </div>
    );
  }

  return children as ReactNode;
};
